import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText, CInputPassword, CToggle, CModal, CInputTextArea } from "../../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../../context";
import { HolidaysEditApi, SingleHolidaysApi } from "../../../api";
import { useNavigate } from "react-router-dom";
import { useParams, Link } from "react-router-dom";
import {  convertStringDateToDateSupport } from "../../../utils";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"

export const HolidaysEdit = () => {
    const navigate = useNavigate()
    const formRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    let params = useParams();
    const [singleData, setSingleData] = useState<any>(null)
    const [defualtDate, setDefualtDate] = useState<any>(null);

    const onChangeValueDate = (e: any, type: string) => {
        let data = { ...defualtDate };
        data[type] = new Date(e?.toDate?.().toString());
        data[`${type}_date`] = convertStringDateToDateSupport(e?.toDate?.().toString());
        setDefualtDate(data)
    }

    const onFinish = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await HolidaysEditApi(formRef, singleData, defualtDate)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast('ویرایش موفقیت آمیز بود', { type: "success" })
            navigate('/p/settings/holidays');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }


    const getData = async () => {
        let res = await SingleHolidaysApi(params.id)
        if (res.success) {
            setSingleData(res.data)
            formRef.current['title'].value = res.data.title;
            formRef.current['description'].value = res.data.description;
            setDefualtDate({
                'start':  new Date(res?.data?.date.slice(0, 10)),
                'start_date': res?.data?.date.slice(0, 10),
            })
        }
    }


    useEffect(() => {
        document.title = "ویرایش روز تعطیل | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 2, })
        getData()
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">ویرایش روز تعطیل</h1>

            <form ref={formRef} onSubmit={onFinish} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">


                <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full md:w-10/12  flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex  items-center pl-0 sm:pl-2">
                            <div className=" w-full h-[50px] pl-1 sm:pl-2">
                                <CInputText name="title" title="عنوان" type="text" required={true} />
                            </div>
                        </div>
                        <div className=" w-full sm:w-[50%] h-[50px] sm:mt-0 mt-5 pr-0 sm:pr-2">
                            <div className={` flex relative px-[7px] h-full rounded-[5px] items-center mb-[3px] border border-dayan-gray-100`}>
                                <span className="text-[12px] text-dayan-gray-100 absolute bg-white top-[-12px] right-[15px] px-[10px]">تاریخ </span>
                                <div className={` jalali-datePicker flex items-center justify-center w-full h-full bg-transparent px-[10px] sm:text-[13px] text-[11px]`} >
                                    <DatePicker calendar={persian} locale={persian_fa} onChange={(e: any) => { onChangeValueDate(e, 'start') }} value={defualtDate?.start} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full md:w-10/12  flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex  items-center pl-0 sm:pl-2">
                            <div className=" w-full pl-1 sm:pl-2">
                                <CInputTextArea name="description" title="توضیحات" custom_class="min-h-[100px]" />
                            </div>
                        </div>
                    </div>
                </div>


                <div className=" w-full mt-[40px] flex items-center">
                    {CtxLoad.displayLoadingBtn ?
                        <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                        :
                        <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                    }
                    <Link to='/p/settings/holidays'>
                        <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                    </Link>
                </div>

            </form>



        </div>
    )
}
